import React from "react";

function SvgIcMapPoi073(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M13 9l10 10-2.715 2.698a7.927 7.927 0 01-1.11.888c-2.26 1.437-5.123 1.128-7.114.626l-.217-.056L9 26l-3-3 2.888-2.888c-.52-1.987-.865-4.89.593-7.18.181-.292.449-.627.712-.92l.196-.209-.004-.004L13 9zm12.597 2.438a1.501 1.501 0 01-.001 2.122L23 16c-.704-.704-1.015-1.087-1.78-1.865l-.177-.18 2.432-2.517a1.504 1.504 0 012.122 0zM21 13.913l.043.043L21 14v-.087zm-.525-7.509a1.501 1.501 0 010 2.121L18 11l-2.122-2.121L16 9l2.352-2.596a1.502 1.502 0 012.123 0z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi073;
